module.exports = __webpack_public_path__ + "static/img/home_icon.34211727.svg";